$bog_fragile_demo_outer_page1 $mol_view
	sub /
		<= Weather $bog_fragile_demo_outer_widget1
			city \Питер
